const ERROR_MESSAGES = Object.freeze({
  UNABLE_TO_GENERATE_SIGNED_URL: 'Unable to generate signed url',
});

export { ERROR_MESSAGES };
